<template>
  <n-flex
    vertical
    align="center"
    justify="center"
    :size="8"
    class="py-10 text-center"
    v-bind="$attrs"
  >
    <p class="text-base text-gray-700">
      <slot name="text">데이터가 없습니다.</slot>
    </p>
    <div v-if="$slots.extra" class="text-sm text-gray-500">
      <slot name="extra"></slot>
    </div>
  </n-flex>
</template>
